import React, {useState, createRef, useEffect} from 'react';
import { useConfig } from '../ConfigContext';

export const MonerisContext = React.createContext({});

export const MonerisProvider = ({ children }) => {
    const [partialPaymentAmount, setPartialPaymentAmount] = useState(null); // stores on client with '$' sign and decimal, remember to strip to number before sending to server
    const [isResourceLoaded, setIsResourceLoaded] = useState(false);
    const {config, configError} = useConfig();

    let monerisRef = createRef();

    /**
   * Moneris actions are at top level due to an issue with placing it at lower level component.
   * The closeCheckout command is not working properly during component cleanup and that means you will end up with multiple instances of Moneris checkout which will call the callbacks multiple times as well.
   */
    const loadMonerisResources = () => {
      return new Promise((resolve, reject) => {
        if(!isResourceLoaded){
          const script = document.createElement("script");
          let scriptSrc;
          if(config.apt_MonerisEnvironment === 'qa'){
            scriptSrc = 'https://gatewayt.moneris.com/chktv2/js/chkt_v2.00.js';
          }else if(config.apt_MonerisEnvironment === 'prod'){
            scriptSrc = 'https://gateway.moneris.com/chktv2/js/chkt_v2.00.js';
          }
          script.src = scriptSrc;
          script.onload = () => { 
            setIsResourceLoaded(true);
            resolve();
          };
          document.body.appendChild(script);

          // check for loaded script
          setTimeout(function () {
            if(!isResourceLoaded) reject("Timeout");
          }, 5000);
        }else{
          resolve();
        }
      });
    }

    const getMonerisCheckout = () => {
      if(!monerisRef.current){
      // eslint-disable-next-line no-undef
        monerisRef.current = new monerisCheckout();
      }
      return monerisRef.current;
    }

    const getNewMonerisCheckout = () => {
      // eslint-disable-next-line no-undef
      monerisRef.current = new monerisCheckout();
      return monerisRef.current;
    }

    const cleanupTransaction = () => {
      let monerisCheckout = getMonerisCheckout();
      if(monerisCheckout.transactionTicket){
          try {
              monerisCheckout.closeCheckout(" ");//monerisCheckout.transactionTicket);
              monerisCheckout.transactionTicket = null;
          } catch (error) {
              //console.error(error);
          }
      }
    };
  
    const provider = {
        loadMonerisResources,
        getMonerisCheckout,
        getNewMonerisCheckout,
        partialPaymentAmount,
        environment:config.apt_MonerisEnvironment,
        setPartialPaymentAmount,
        cleanupTransaction
    };

    return (
      <MonerisContext.Provider value={provider}>{children}</MonerisContext.Provider>
    );
  };